import React from "react";
import { Helmet } from "react-helmet";
import "../styles/Qanunvericilik.css";

const Qanunvericilik = () => {
  return (
    <div className="qanunvericilik-page">
      <Helmet>
        <title>Qanunvericilik | DostTech</title>
        <meta
          name="description"
          content="DostTech.az rəsmi hüquqi, vergi, çatdırılma və ödəniş məlumatları; Dosttech haqqında əsas məqamlar."
        />
      </Helmet>
      <div className="container qanunvericilik-inner">
        <h1 className="qanunvericilik-title">Qanunvericilik</h1>
        <p className="qanunvericilik-intro">
          Bu səhifədə veb-saytın hüquqi əsasları, vergi və qiymət siyasəti,
          çatdırılma, ödəniş üsulları, Dosttech fəaliyyəti haqqında əsas məqamlar
          və məlumatların istifadəsi barədə qısa məlumatlar dövlət qurumları və
          digər maraqlı tərəflər üçün təqdim olunur.
        </p>

        <section className="qanunvericilik-section" aria-labelledby="sec-legal-entity">
          <h2 id="sec-legal-entity">Rəsmi hüquqi məlumatlar</h2>
          <p>
            <strong>Fiziki şəxs:</strong> Sadıxov Firudin Mənşur oğlu
          </p>
          <p className="mt-2 mb-0">
            <strong>VÖEN / vergi identifikasiya nömrəsi (Tax ID):</strong>{" "}
            1906207542
          </p>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-address">
          <h2 id="sec-address">Qeydiyyat ünvanı</h2>
          <p className="mb-0">
            Mərdəkan qəs. S.Yesenin küç 106
          </p>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-vat">
          <h2 id="sec-vat">Vergi haqqında</h2>
          <p className="mb-0">Qiymətlərə ƏDV daxildir.</p>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-delivery">
          <h2 id="sec-delivery">Çatdırılma</h2>
          <p className="mb-0">
            Çatdırılma xidməti ödənişsizdir (Bakı ətrafı).
          </p>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-payment">
          <h2 id="sec-payment">Ödəniş üsulları</h2>
          <p className="mb-0">
            Nağd və plastik kartlar ilə ödəniş mümkündür.
          </p>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-about">
          <h2 id="sec-about">Dosttech haqqında əsas məqamlar</h2>
          <h3>Yaranma tarixi</h3>
          <p>
            Şirkət 24 avqust 2004-cü ildə təsis edilmişdir.
          </p>
          <h3>Məhsul çeşidi</h3>
          <p>
            Notbuklar, kompüter texnikası, televizorlar, audio/foto avadanlıqlar,
            böyük məişət texnikası, kondisionerlər, mobil telefon aksesuarları və
            s.
          </p>
          <h3>Xidmətlər</h3>
          <p className="mb-0">Korporativ satış, çatdırılma mövcuddur.</p>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-data-use">
          <h2 id="sec-data-use">TOPLANMIŞ MƏLUMATLARIN İSTİFADƏSİ</h2>
          <p>
            Biz sizin məlumatlarınızı aşağıdakı məqsədlərlə istifadə edə bilərik:
          </p>
          <ul>
            <li>
              Tələblərinizə cavab vermək məqsədilə xidmətlərimizi yaxşılaşdırmaq
              və təkmilləşdirmək üçün müştərilərimiz və onların tələbləri ilə
              daha yaxından tanış olmaq.
            </li>
            <li>Sizi daha yaxşı müştəri dəstəyi ilə təmin etmək.</li>
            <li>
              Sizinlə ünsiyyət qurmaq. Yeni işlərimiz barədə məlumat əldə
              etməyinizə imkan yaratmaq.
            </li>
          </ul>
        </section>

        <section className="qanunvericilik-section" aria-labelledby="sec-third-parties">
          <h2 id="sec-third-parties">Üçüncü tərəflər</h2>
          <p className="mb-0">
            Qüvvədə olan qanunvericiliyə müvafiq olaraq ödəniş sistemi təminatçısı
            kimi xidmət təminatçıları və ya digər tranzaksiya prosessoru tərəfindən
            tələb olunmadığı halda biz sizin şəxsi məlumatlarınızı üçüncü tərəflərə
            ötürmürük.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Qanunvericilik;
